// import { log } from 'console';

export const authConfig = {
  login: 'api/v1/api-gateway/admin-auth/login',
  register: 'admin/register',
  forgot_password: 'admin/forgot-password',
  set_password: 'admin/set-password',
  verify: 'admin/verify-otp',
  resendOTP: 'admin/resend-otp',
  updateDevice: 'api/v1/api-gateway/admin-auth/update-device',
};
